import { connect, Field as FormikField, FieldArray } from 'formik'
import { Button, Field } from '@/ui'
import React, { Fragment, useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Plus } from '@app/images'
import { InjuredItem } from '@features/accidents/steps/accidentReport/InjuredItem'


export const Victim = connect(
	({
		 formik: { setFieldValue, values, resetForm, setValues },
	 }) => {
		const { t } = useTranslation()

		return (
			<>
				<FieldArray name={'injureds'}>
					{({ push, remove }) => {
						return (
							<>
								{values.injureds?.map((item, index) => {
									return (
										<InjuredItem key={index} item={item} index={index}/>
									)
								})}

								<section>
									<Button
										textColor="green"
										borderColor="green"
										transparent
										border
										type="button"
										icon={Plus}
										onClick={() => push({ isResident: true })}
									>
										{t('accidentsPage.register.addVictim')}
									</Button>
								</section>
							</>
						)
					}}
				</FieldArray>
			</>
		)
	},
)
